import { render, staticRenderFns } from "./SeleccionarAsientoConSecciones.vue?vue&type=template&id=7106a133"
import script from "./SeleccionarAsientoConSecciones.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientoConSecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports